var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.lineas.length > 1,
              expression: "lineas.length > 1"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c("div", { staticClass: "form-field select2" }, [
            _c(
              "div",
              { staticClass: "select2-field" },
              [
                _c("v-select", {
                  attrs: {
                    options: _vm.lineas,
                    label: "name",
                    id: "linea",
                    placeholder: "Seleccione..."
                  },
                  on: { input: _vm.inputLinea },
                  model: {
                    value: _vm.selectedLinea,
                    callback: function($$v) {
                      _vm.selectedLinea = $$v
                    },
                    expression: "selectedLinea"
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "linea" } }, [_vm._v("Línea")]),
                _vm._v(" "),
                _vm.errores.linea_id
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.linea_id[0]))])]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("div", { staticClass: "form-field select2" }, [
          _c(
            "div",
            { staticClass: "select2-field" },
            [
              _c("v-select", {
                attrs: {
                  label: "address",
                  options: _vm.yards,
                  id: "yard_code",
                  placeholder: "Seleccione..."
                },
                on: { input: _vm.inputYard },
                model: {
                  value: _vm.selectedYard,
                  callback: function($$v) {
                    _vm.selectedYard = $$v
                  },
                  expression: "selectedYard"
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "yard_code" } }, [_vm._v("Patio")]),
              _vm._v(" "),
              _vm.errores.yard_code
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [_c("strong", [_vm._v(_vm._s(_vm.errores.yard_code[0]))])]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  readonly: _vm.tipoFormulario !== "N",
                  id: "numero_oficio",
                  placeholder: "# Oficio"
                },
                model: {
                  value: _vm.form.numero_oficio,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "numero_oficio", $$v)
                  },
                  expression: "form.numero_oficio"
                }
              },
              [
                _c("span", [_vm._v("Número de oficio")]),
                _vm._v(" "),
                _vm.errores.numero_oficio
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.numero_oficio[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  readonly: _vm.tipoFormulario !== "N",
                  id: "contenedor",
                  placeholder: "#######"
                },
                model: {
                  value: _vm.form.contenedor,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "contenedor", $$v)
                  },
                  expression: "form.contenedor"
                }
              },
              [
                _c("span", [_vm._v("Contenedor")]),
                _vm._v(" "),
                _vm.errores.contenedor
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.contenedor[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("div", { staticClass: "form-field select2" }, [
          _c(
            "div",
            { staticClass: "select2-field" },
            [
              _c("v-select", {
                attrs: {
                  taggable: "",
                  options: _vm.naves,
                  label: "nave",
                  id: "nave",
                  placeholder: "Seleccione..."
                },
                model: {
                  value: _vm.form.nave,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "nave", $$v)
                  },
                  expression: "form.nave"
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "nave" } }, [_vm._v("Nave")]),
              _vm._v(" "),
              _vm.errores.nave
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [_c("strong", [_vm._v(_vm._s(_vm.errores.nave[0]))])]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "viaje", placeholder: "Viaje" },
                model: {
                  value: _vm.form.viaje,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "viaje", $$v)
                  },
                  expression: "form.viaje"
                }
              },
              [
                _c("span", [_vm._v("Viaje")]),
                _vm._v(" "),
                _vm.errores.viaje
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.viaje[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "embarque", placeholder: "Embarque" },
                model: {
                  value: _vm.form.embarque,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "embarque", $$v)
                  },
                  expression: "form.embarque"
                }
              },
              [
                _c("span", [_vm._v("Embarque")]),
                _vm._v(" "),
                _vm.errores.embarque
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.embarque[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "datepicker-field" },
            [
              _c("date-picker", {
                attrs: { type: "date", id: "arriva_nave" },
                model: {
                  value: _vm.form.arriva_nave,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "arriva_nave", $$v)
                  },
                  expression: "form.arriva_nave"
                }
              }),
              _vm._v(" "),
              _c("label", [_vm._v("Fecha de Nave")]),
              _vm._v(" "),
              _vm.errores.arriva_nave
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [_c("strong", [_vm._v(_vm._s(_vm.errores.arriva_nave[0]))])]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { placeholder: "Imp", id: "importador" },
                model: {
                  value: _vm.form.importador,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "importador", $$v)
                  },
                  expression: "form.importador"
                }
              },
              [
                _vm._v(
                  "\n                    Importador\n                    "
                ),
                _vm.errores.importador
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.importador[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: { placeholder: "RUC", id: "importador" },
                  model: {
                    value: _vm.form.ruc_importador,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "ruc_importador", $$v)
                    },
                    expression: "form.ruc_importador"
                  }
                },
                [
                  _vm._v(
                    "\n                        RUC Importador\n                        "
                  ),
                  _vm.errores.ruc_importador
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores.ruc_importador[0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("div", { staticClass: "form-field select2" }, [
          _c(
            "div",
            { staticClass: "select2-field" },
            [
              _c("v-select", {
                attrs: {
                  taggable: "",
                  options: _vm.telefonos,
                  id: "tel_importador",
                  placeholder: "Seleccione..."
                },
                model: {
                  value: _vm.form.tel_importador,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "tel_importador", $$v)
                  },
                  expression: "form.tel_importador"
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "tel_importador" } }, [
                _vm._v("Tel. Importador")
              ]),
              _vm._v(" "),
              _vm.errores.tel_importador
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.errores.tel_importador[0]))
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("div", { staticClass: "form-field select2" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "select-field" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.size,
                      expression: "form.size"
                    }
                  ],
                  attrs: { name: "size", id: "size" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.form,
                        "size",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "4" } }, [_vm._v("4")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "2" } }, [_vm._v("2")])
                ]
              ),
              _vm._v(" "),
              _c("label", { attrs: { for: "tipo_contenedor" } }, [
                _vm._v("Tipo de contenedor")
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "select2-field" },
              [
                _c("v-select", {
                  attrs: {
                    options: _vm.tiposContenedor,
                    label: "descripcion",
                    id: "tipo_contenedor",
                    placeholder: "Seleccione..."
                  },
                  on: { input: _vm.inputTipoContenedor },
                  model: {
                    value: _vm.selectedTipoContenedor,
                    callback: function($$v) {
                      _vm.selectedTipoContenedor = $$v
                    },
                    expression: "selectedTipoContenedor"
                  }
                }),
                _vm._v(" "),
                _vm.errores.tipo_contenedor
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.tipo_contenedor[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "datepicker-field" },
            [
              _c("date-picker", {
                attrs: { type: "date", id: "fecha_inicio" },
                model: {
                  value: _vm.form.fecha_inicio,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "fecha_inicio", $$v)
                  },
                  expression: "form.fecha_inicio"
                }
              }),
              _vm._v(" "),
              _c("label", [_vm._v("Fecha de inicio")]),
              _vm._v(" "),
              _vm.errores.fecha_inicio
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.errores.fecha_inicio[0]))
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "datepicker-field" },
            [
              _c("date-picker", {
                attrs: { type: "date", id: "fecha_caducidad" },
                model: {
                  value: _vm.form.fecha_caducidad,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "fecha_caducidad", $$v)
                  },
                  expression: "form.fecha_caducidad"
                }
              }),
              _vm._v(" "),
              _c("label", [_vm._v("Fecha de caducidad")]),
              _vm._v(" "),
              _vm.errores.fecha_caducidad
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.errores.fecha_caducidad[0]))
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "sello", placeholder: "#######" },
                model: {
                  value: _vm.form.sello,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "sello", $$v)
                  },
                  expression: "form.sello"
                }
              },
              [
                _c("span", [_vm._v("Sello")]),
                _vm._v(" "),
                _vm.errores.sello
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.sello[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "bl", placeholder: "#######" },
                model: {
                  value: _vm.form.bl,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "bl", $$v)
                  },
                  expression: "form.bl"
                }
              },
              [
                _c("span", [_vm._v("BL")]),
                _vm._v(" "),
                _vm.errores.bl
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.bl[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "mrn", placeholder: "#######" },
                model: {
                  value: _vm.form.mrn,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "mrn", $$v)
                  },
                  expression: "form.mrn"
                }
              },
              [
                _c("span", [_vm._v("MRN")]),
                _vm._v(" "),
                _vm.errores.mrn
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.mrn[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "marca", placeholder: "#######" },
                model: {
                  value: _vm.form.marca,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "marca", $$v)
                  },
                  expression: "form.marca"
                }
              },
              [
                _c("span", [_vm._v("Marca")]),
                _vm._v(" "),
                _vm.errores.marca
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.marca[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c(
        "button",
        {
          staticClass: "btn-success",
          attrs: { type: "button" },
          on: { click: _vm.guardar }
        },
        [
          _c("i", { staticClass: "fa fa-save" }),
          _vm._v(" "),
          _c("span", [_vm._v("Guardar")])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("cancelar")
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-ban" }),
          _c("span", [_vm._v("Cancelar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [_c("h3", [_vm._v("Ecas")])])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3634aea0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3634aea0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/ecas-coparn/Ecas.vue
// module id = 421
// module chunks = 0